export default __webpack_public_path__ + "static/media/ch5-sponsor.54aa115d.png";